import { render, staticRenderFns } from "./ListDealer.vue?vue&type=template&id=0d582235&scoped=true&"
import script from "./ListDealer.vue?vue&type=script&lang=js&"
export * from "./ListDealer.vue?vue&type=script&lang=js&"
import style0 from "./ListDealer.vue?vue&type=style&index=0&id=0d582235&lang=scss&scoped=true&"
import style1 from "./ListDealer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d582235",
  null
  
)

export default component.exports